// document ready
jQuery(document).ready(function ($) {

    // variables
    let hide_cart_notification;

    // sorting dropdown on change fire the form
    $('#product-archive-sorting').on('change', ':input', function () {

        // submit the selected option
        $('#product-archive-sorting').submit();

    });

    // product archive view
    $('#product-archive-view').on('click', 'BUTTON', function(e) {

        // make changes to the clicked button in question
        $(this).addClass('active').siblings().removeClass('active');

        // if element clicked is equal to large
        if( $(this).data('size') === 'lg' ) {

            // add grid size large class
            $('#product-archive').addClass('view-lg');

            // update the local storage item
            Cookies.set('wm_arc_view_lg', 1);

        } else {

            // remove grid size large class
            $('#product-archive').removeClass('view-lg');

            // remove the local storage item
            Cookies.remove('wm_arc_view_lg');

        }

    });

    // product get quick view data into model
    function selected_option_price(product_id, option_id, qty) {

        // set our vars
        $price = $('.price-data','.product-single-info');

        // add class before loading ajax
        $price.addClass('opac-50');

    // jquery ajax call
    $.ajax({
        cache: false,
        timeout: 30000,
        url: admin_ajax_url,
        type: 'GET',
        data: {
            action : 'selected_option_price',
            product_id  : product_id,
            option_id : option_id,
            qty : qty
        },
        success: function (data) {

            // add class before loading ajax
            $price.removeClass('opac-50');

            // render on single product infp tempate
            $price.html(data);

        }
    });

    }

    // product single select on change in order options update price
    $(document).on('change', '#product-options-items', function (e) {

        // prevent default
        e.preventDefault();

        // get our vars
        const product_id  = parseInt($(this).closest('.product-single').data('id'));
        const option_id   = parseInt($(this).val());
        const qty         = parseInt($(this).closest('.product-single').find('#product-options-qty').val());

        // update the options price
        selected_option_price(product_id,option_id,qty);

        // get the slide index
        let slideIndex = $OptionsGallerySlider.find('[data-option="' + option_id + '"]').closest('.slick-slide').data('slick-index');

        // fire go to slide
        $OptionsGallerySlider.slick('slickPause').slick('slickGoTo', slideIndex);

    });

    // product single qty on change
    $(document).on('input', '#product-options-qty', function (e) {

        // prevent default
        e.preventDefault();

        // product options form
        let $options_form = $('.product-options');

        // get our vars
        const product_id  = parseInt($(this).closest('.product-single').data('id'));
        const option_id   = parseInt($(this).closest('.product-single').find('#product-options-items').val());
        const qty         = parseInt($(this).val());

        // if option id is false
        if(!option_id) {
            alert('Please choose an option.');
            $(this).val('1');
            return;
        }

        // min max values
        if(qty > 0 && qty <= 99) {
            // update the options price
            selected_option_price(product_id, option_id, qty);
        }

    }).on('change', '#product-options-qty', function (e) {

        // get our vars
        var product_id  = parseInt($(this).closest('.product-single').data('id'));
        var option_id   = parseInt($(this).closest('.product-single').find('#product-options-items').val());
        var qty = parseInt($(this).val());

        // if option id is false
        if(!qty) {
            alert('Enter between 1 and 99');
            $(this).val('1');

            // update the options price
            selected_option_price(product_id, option_id, qty);
            return;

        }

        // min max values
        if(qty < 1 || qty > 99) {
            alert('Enter between 1 and 99');

            if(qty < 1) {
                // update the options price
                $(this).val('1');
                selected_option_price(product_id, option_id, 1);
                return;

            } else if (qty > 99) {
                // update the options price
                $(this).val('99');
                selected_option_price(product_id, option_id, 99);
                return;

            }
        }

    });

    // product add to cart button
    $(document).on('click', '#product-add-cart', function (e) {

        // prevent default
        e.preventDefault();

        // get current time
        let d = new Date();

        // get our vars
        let product_id  = parseInt( $(this).closest('.product-single').data('id') );
        let option_id   = parseInt( $(this).closest('.product-single').find('#product-options-items').val() );
        let qty         = parseInt( $(this).closest('.product-single').find('#product-options-qty').val() );

        // if option id is false
        if(!option_id) {
            alert('Please choose an option.');
            return;
        }

        // min max values
        if(qty < 1 && qty > 99) {
            alert('Enter between 1 and 99');
            return;
        }

        // create our unique id combo as float
        let id = parseFloat(product_id + '.' + option_id );

        // if cookie cart exists
        if(Cookies.get('wm_cart')) {

            // get the cart contents
            let cart = Cookies.getJSON('wm_cart');

            // update cart items
            cart = add_cart_item(cart,id,qty,d);

            // update cookie
            Cookies.set('wm_cart', {
                updated: cart.updated,
                items: cart.items
            });

            // update the cart count
            cart_count();

            console.log('cookie cart updated');
            console.log(cart);

        } else {

            let time = d.getTime();

            // begin a new cart
            let cart = {
                'updated' : {
                    'time' : time,
                    'item' : id
                },
                'items' : {}
            };

            // populate our new cart
            cart.items[id] = {
                qty: qty
            };

            // lets create a cart
            Cookies.set('wm_cart', cart);

            // update the cart count
            cart_count();

            console.log('cookie cart created');
            console.log(cart);

        }

        cart_notification_modal();

    });

    // update cart items
    function add_cart_item(cart, id, qty, d) {

        // update the time stamp in the array
        cart.updated.time = d.getTime();
        cart.updated.item = id;

        // // if id exists in cart items
        if (cart.items[id]) {

            // quantity vars
            let current_qty = parseInt(cart.items[id].qty);
            let updated_qty = current_qty + qty;

            // update new quantity
            cart.items[id].qty = updated_qty;

        } else {

            // add new item and quantity
            cart.items[id] = {
                qty: qty
            };

        }

        return cart;

    }

    // update cart items
    function update_cart_item(cart, id, qty, d) {

        // update the time stamp in the array
        cart.updated.time = d.getTime();

        // if quantity is zero
        if(qty === 0) {

            // delete the item
            delete cart.items[id];

            // get last item
            let lastItem = Object.keys(cart.items)[Object.keys(cart.items).length - 1];

            // update with last item in list
            cart.updated.item = lastItem;

            // return cart data
            return cart;

        }

        // if id exists in cart items
        if (cart.items[id]) {

            // update new quantity
            cart.items[id].qty = qty;
            cart.updated.item = id;

        } else {

            // add new item and quantity
            cart.items[id] = {
                qty: qty
            };
            cart.updated.item = id;

        }

        // return cart data
        return cart;

    }

    // cart btn count bubble
    function cart_count() {

        let count = 0;

        // count items in cart
        function count_cart_items(cart) {

            // count the quantities
            $.each(cart.items, function(id, item) {
                // accumulate qty
                count = count + item.qty;
            });

            // count is big
            if(count > 99) {
                count = '99+';
            }

            // update the count bubble
            $('.count', '#btn-cart').html(count).addClass('show');

        }

        // if cookie cart exists
        if(Cookies.get('wm_cart')) {

            // get the cart contents
            let cart = Cookies.getJSON('wm_cart');

            // count items
            count_cart_items(cart);

        }

    } cart_count();

    // update cart quantity inputs in cart table
    $(document).on('input','.cart-item-qty', function (e) {

        e.preventDefault();

        // reset quote model html
        reset_modal_html_loading('.modal-quote');

        // if value is empty then set back to 1
        if($(this).val() === '') {
            $(this).val('1');
        }

        // get current time
        let d = new Date();

        // get our vars
        const product_id    = parseInt($(this).closest('.cart-item').data('id'));
        const option_id     = parseInt($(this).closest('.cart-item').data('option'));
        const qty           = parseInt($(this).val());

        // create our unique id combo as float
        let id = parseFloat(product_id + '.' + option_id );

        // if cookie cart exists
        if(Cookies.get('wm_cart')) {

            // get the cart contents
            let cart = Cookies.getJSON('wm_cart');

            // update cart items
            cart = update_cart_item(cart,id,qty,d);

            // check how many items cookie has
            if(Object.keys(cart.items).length === 0) {

                // update cookie
                Cookies.remove('wm_cart');

                // remove the count
                $('.count','#btn-cart').removeClass('show');

                console.log('cart removed');

            } else {

                // update cookie
                Cookies.set('wm_cart', {
                    updated: cart.updated,
                    items: cart.items
                });

                console.log('cart updated');

            }

            // update the cart count and summary
            cart_count();
            reload_cart_order_table();

        }

    }).on('keydown', '.cart-item-qty', function (e) {

        // if key is enter then prevent defaults
        if(e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();
        }

    });


    // update the user cart
    function update_user_cart (cart) {

        // update the user cart
        $.ajax({
            cache: false,
            timeout: 30000,
            url: admin_ajax_url,
            type: 'GET',
            data: {
                action  : 'update_cart',
                cart    : cart
            },
            success: function (response) {

                // reload the basket
                console.log('user cart created');
                // console.log(cart);

            }
        });

    }

    // reload your cart
    function reload_cart_order_table () {

        // jquery ajax call
        $.ajax({
            cache: false,
            timeout: 30000,
            url: admin_ajax_url,
            type: 'GET',
            data: {
                action : 'reload_cart_order_table'
            },
            success: function (data) {

                // load the data into modal
                $('.cart-order-table-wrapper').html(data);

            }
        });

    }


    // show added to cart notification
    function cart_notification () {

        if($('BODY').hasClass('cart-notification-open')) {

            // toggle class to open notification
            $('BODY').toggleClass('cart-notification-open');

        } else {

            $('#cart-notification').remove();

            // jquery ajax call
            $.ajax({
                cache: false,
                timeout: 30000,
                url: admin_ajax_url,
                type: 'GET',
                data: {
                    action : 'reload_cart_notification'
                },
                success: function (data) {

                    // load the data into modal
                    $('.container','#header').append(data).ready(function () {

                        // toggle class to open notification
                        $('BODY').toggleClass('cart-notification-open');

                        // scroll top of page
                        $('HTML, BODY').animate({ scrollTop: 0 }, 500 );

                    });

                }
            });

        }

    }


    // modal cart notification
    let $cart_notification_modal        = $('#modal-cart-notification');
    let hide_cart_notification_modal;


    // get cart notification modal
    function cart_notification_modal () {

        // jquery ajax call
        $.ajax({
            cache: false,
            timeout: 30000,
            url: admin_ajax_url,
            type: 'GET',
            data: {
                action : 'reload_cart_notification_modal'
            },
            success: function (data) {

                // modal show
                $cart_notification_modal.modal('show');

                // modal html data
                $cart_notification_modal.find('.modal-content').html(data).ready(function () {

                    // close notification automatically
                    hide_cart_notification_modal = setTimeout(function() {

                        // remove the body open notification class
                        $cart_notification_modal.modal('hide');

                    },4000);

                });

            }
        });

    }


    // cart notification modal hidden 1-5031000030431
    $cart_notification_modal.on('show.bs.modal', function (e) {

        // get the modal id
        let modal_id = $cart_notification_modal.attr('id');

        // set time out
        setTimeout(function(){

            // add modal id to last backdrop
            $('.modal-backdrop:last-child').attr('id',modal_id + '-backdrop');

        });

    }).on('hidden.bs.modal', function (e) {

        // if a modal is still visible
        if ($('.modal:visible').length) {
            $('BODY').addClass('modal-open');
        }

        // reset the modal html loading
        reset_modal_html_loading('#modal-cart-notification');

        // clear the time out if closed early
        clearTimeout(hide_cart_notification_modal);

    });


    // cart button header open notification
    $(document).on('click', '#btn-cart', function(e) {

        // prevent defaults
        e.preventDefault();

        // cart notification
        cart_notification_modal();

    });


    // reset quote modal html
    function reset_modal_html_loading (modal) {

        // modal quote data loaded change to false
        $(modal).data('loaded',false);

        // reset the html to font awesome spinner
        $('.modal-content',modal).html('<div class="p-5 text-center"><i class="fas fa-circle-notch fa-spin fa-2x"></i></div>');

    }


});